import { RobotTutorial } from './types';

export const getRobotTutorials = async (
  robotIp: string | undefined
): Promise<RobotTutorial[]> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  const response = await fetch(`http://${robotIp}/flows/tutorials`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Get Robot Tutorials returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }

  return await response.json();
};

export const triggerRobotFlow = async (
  robotIp: string | undefined,
  flowId: RobotTutorial['id']
): Promise<void> => {
  if (robotIp === undefined) {
    throw new Error('RobotIP is undefined');
  }

  if (flowId === undefined) {
    throw new Error('Robot flow is undefined');
  }

  const response = await fetch(`http://${robotIp}/flows/trigger`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: flowId }),
  });

  if (!response.ok) {
    throw new Error(
      `Triggering the robot tutorial returned not-ok error code (${
        response.status
      }): ${await response.text()}`
    );
  }
};
